// Veli tercih sistemi — basit ağırlıklı puanlama (0-100)
// localStorage'da tutulan tercihleri okul özellikleriyle eşleştirir.

export const PRIORITY_OPTIONS = [
  { id:'ingilizce', label:'🇬🇧 İngilizce ağırlıklı', kws:['ingilizce','english','dil','yabancı dil'] },
  { id:'bahceli',   label:'🌳 Bahçeli',              kws:['bahçe','bahce','dış alan','park'] },
  { id:'doga',      label:'🌿 Doğa Temalı',          kws:['doğa','orman','doga','tabiat'] },
  { id:'servis',    label:'🚌 Servis Var',           kws:['servis','taşıma','araç'] },
  { id:'yemek',     label:'🍽️ Yemek dahil',          kws:['yemek','organik yemek','kantin','beslenme'] },
  { id:'spor',      label:'⚽ Spor olanakları',      kws:['spor','jimnastik','futbol','basketbol'] },
  { id:'yuzme',     label:'🏊 Yüzme Havuzu',         kws:['havuz','yüzme'] },
  { id:'sanat',     label:'🎨 Sanat Atölyesi',       kws:['sanat','resim','atölye','tiyatro'] },
  { id:'muzik',     label:'🎵 Müzik Eğitimi',        kws:['müzik','muzik','enstrüman','piyano'] },
  { id:'stem',      label:'🤖 STEM/Robotik',          kws:['stem','steam','kodlama','robotik','bilim'] },
  { id:'montessori',label:'📚 Montessori',            kws:['montessori'] },
  { id:'reggio',    label:'🧠 Reggio Emilia',         kws:['reggio','emilia'] },
  { id:'waldorf',   label:'🌱 Waldorf',              kws:['waldorf'] },
  { id:'guvenlik',  label:'📹 Güvenlik kamerası',    kws:['kamera','güvenlik','kartlı giriş'] },
  { id:'saglik',    label:'🏥 Sağlık personeli',     kws:['hemşire','sağlık','revir'] },
  { id:'dini',      label:'🕌 Dini Eğitim',          kws:['dini','imam','hatip','kuran','islami','din','imam-hatip'] },
];

const PREF_KEY = 'okulmap_prefs_v1';

export function loadPrefs() {
  try {
    const raw = localStorage.getItem(PREF_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (!p || typeof p !== 'object') return null;
    return p;
  } catch (e) { return null; }
}

export function savePrefs(prefs) {
  try { localStorage.setItem(PREF_KEY, JSON.stringify(prefs)); } catch(e) {}
}

export function clearPrefs() {
  try { localStorage.removeItem(PREF_KEY); } catch(e) {}
}

const norm = s => (s||'').toLowerCase()
  .replace(/ı/g,'i').replace(/İ/g,'i').replace(/I/g,'i')
  .replace(/ş/g,'s').replace(/ğ/g,'g').replace(/ü/g,'u')
  .replace(/ö/g,'o').replace(/ç/g,'c');

function hasFeature(p, kws) {
  if (!p.features || !p.features.length) return false;
  const featStr = p.features.map(f => norm(f)).join(' ');
  return kws.some(k => featStr.includes(norm(k)));
}

// Skor 0-100. Tercih yoksa null döner.
export function matchScore(p, prefs) {
  if (!prefs) return null;
  let score = 0;
  let maxScore = 0;

  // Yaş uyumu (ağırlık 25)
  if (prefs.childAge != null) {
    maxScore += 25;
    const a = +prefs.childAge;
    if (p.ageMin <= a && p.ageMax >= a) score += 25;
    else if (p.ageMin <= a+1 && p.ageMax >= a-1) score += 12;
  }

  // Bütçe uyumu (ağırlık 25)
  if (prefs.maxBudget && prefs.maxBudget > 0) {
    maxScore += 25;
    if (p.priceNum === 0) score += 12; // bilinmiyor
    else if (p.priceNum <= prefs.maxBudget) score += 25;
    else if (p.priceNum <= prefs.maxBudget * 1.15) score += 14;
    else if (p.priceNum <= prefs.maxBudget * 1.30) score += 6;
  }

  // Öncelik özellikleri (ağırlık 50 / öncelik sayısı)
  if (prefs.priorities && prefs.priorities.length > 0) {
    const w = 50 / prefs.priorities.length;
    prefs.priorities.forEach(pid => {
      maxScore += w;
      const opt = PRIORITY_OPTIONS.find(o => o.id === pid);
      if (opt && hasFeature(p, opt.kws)) score += w;
    });
  }

  if (maxScore === 0) return null;
  return Math.round((score / maxScore) * 100);
}

export function scoreColor(score) {
  if (score >= 85) return '#4ECDC4';
  if (score >= 70) return '#7BE495';
  if (score >= 50) return '#FFE66D';
  return '#FF8C42';
}
